import { Mutation, MutationTree } from "vuex";
import {
  HomePageMutation,
  HomePageState,
  IndexData,
  SlideIndexMapParams
} from "@/components/homePage/types";

export const mutations: MutationTree<HomePageState> &
  Record<HomePageMutation, Mutation<HomePageState>> = {
  [HomePageMutation.setPlayedChannelIndex](state, index?: number) {
    state.playedChannelIndex = index;
  },
  [HomePageMutation.setWidgetKeyControl](state, status: boolean) {
    state.widgetKeyControl = status;
  },
  [HomePageMutation.setActiveSlideIndexMap](
    state,
    params?: SlideIndexMapParams
  ) {
    if (params?.addItem === true) {
      state.activeSlideIndexMap.push(0);
      return;
    }
    if (params?.slideIndex) {
      state.activeSlideIndexMap[params?.slideIndex.valueIndex] =
        params?.slideIndex.value;
    }
  },
  [HomePageMutation.resetActiveSlideIndexMap](state) {
    state.activeSlideIndexMap = [];
  },
  [HomePageMutation.setPlayedWidgetIndex](state, widgetItemIndex?: IndexData) {
    state.playedWidgetIndex = widgetItemIndex ? widgetItemIndex : undefined;
  },
  [HomePageMutation.setPromotionKeyControl](state, status: boolean) {
    state.promotionKeyControl = status;
  }
};
